export const queryKeys = {
  catalog: (itemCode: string, serialNo?: string) =>
    serialNo ? ['catalog', itemCode, serialNo] as const : ['catalog', itemCode] as const,
  componentCatalog: (itemCode: string) => ['componentCatalog', itemCode] as const,
  tickets: (incidentId: string) => ['tickets', incidentId] as const,
  ticket: (externalId: string) => ['ticket', externalId] as const,
} as const;
